export const FaqUpdateMapper = (datalist) => {
    let result = { status: null, data: [] };
    if (datalist) {
        result.status = datalist.status;
        result.data = datalist.data;
    }
    return result;
};
